import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    sellingTooltip:
      'This includes any transaction involving the transfer of ownership of a tangible asset (that is, an asset with a material existence), as well as all catering and accommodation activities.',
    serviceTooltip:
      'This refers to any transaction that does not involve the transfer of ownership of tangible assets (that is, assets that have a physical existence).',
  },
  fr: {
    sellingTooltip:
      "Il s’agit de toute opération comportant le transfert de propriété d'un bien corporel (c'est-à-dire un bien ayant une existence matérielle), ainsi que toutes les activités de restauration et d'hébergement.",
    serviceTooltip:
      "Il s’agit de toute opération ne comportant pas de transfert de propriété de biens corporels (c'est-à-dire ayant une existence matérielle).",
  },
} as const);
